import React, { useEffect, useState } from "react";
import { Security, LoginCallback } from "@okta/okta-react";
import { Router, Switch, Route } from "react-router-dom";
import { toRelativeUrl } from "@okta/okta-auth-js";
import { LoginHandler } from "@tailormed/common-client/component/LoginHandler";
import { ServerError } from "@tailormed/common-client/component/ServerError";
import { selectServerError } from "@tailormed/common-client/store/selector";
import { getAuthInstance } from "@tailormed/common-client/services/auth";

import { Login } from "../screen/Login";
import { Routes } from "../constant/routes";
import { SecuredRouter } from "./SecuredRouter";
import { useSelector } from "react-redux";
import { history } from "./history";
import { oktaConfig } from "../constant/okta";
import {
  ErrorPageLayout,
  AppLayout,
  LogoContainer,
  TailormedLogoIcon,
  TailormedVisualIcon,
  TailormedLogoContainer,
  TailormedHeaderText
} from "../component/AppLayout";
import { ContactSupport } from "../component/ContactSupport";

const MainRouter = () => {
  const [oktaAuth, setOktaAuth] = useState(null);
  const clientId = useSelector((state) => state.oktaClientId);
  const [redirectedToLogin, setRedirectedToLogin] = useState(false);

  const hasServerError = useSelector(selectServerError);

  useEffect(() => {
    if (clientId) {
      setOktaAuth(getAuthInstance(oktaConfig?.redirectUri, clientId));
    }
  }, [clientId]);

  const onAuthRequired = () => {
    setRedirectedToLogin(true);
    history.push(Routes.ROOT + Routes.LOGIN);
  };

  if (hasServerError) {
    return (
      <Router history={history}>
        <ServerError
          ErrorPageLayout={ErrorPageLayout}
          AppLayout={AppLayout}
          LogoContainer={LogoContainer}
          TailormedLogoIcon={TailormedLogoIcon}
          TailormedVisualIcon={TailormedVisualIcon}
          TailormedLogoContainer={TailormedLogoContainer}
          TailormedHeaderText={TailormedHeaderText}
        />
      </Router>
    );
  }

  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    history.replace(toRelativeUrl(originalUri || "/", window.location.origin));
  };

  return oktaAuth ? (
    <Router history={history}>
      <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri} onAuthRequired={onAuthRequired}>
        <LoginHandler />
        <Switch>
          <Route path={Routes.ROOT + Routes.LOGIN + Routes.CALLBACK} component={LoginCallback} />
          <Route path={Routes.ROOT + Routes.LOGIN}>
            <Login redirectedToLogin={redirectedToLogin} />
          </Route>
          <Route path={"/"} component={SecuredRouter} />
        </Switch>
      </Security>
      <ContactSupport />
    </Router>
  ) : null;
};

export { MainRouter };
